import {
    ReactNode, useEffect, useRef, useState,
} from 'react';

export const ANIMATION_DURATION_MS = 300;

interface Props {
    children?: ReactNode;
    initialOpen?: boolean;
}

function useAccordion({ children, initialOpen }:Props) {
    const [expand, setExpand] = useState(initialOpen || false);
    const [maxHeight, setMaxHeight] = useState<number>(0);
    const [isLoad, setIsLoad] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (ref.current) {
            setMaxHeight(ref.current.scrollHeight);
            const timeout = setTimeout(() => {
                setIsLoad(true);
            }, ANIMATION_DURATION_MS);
            return () => clearTimeout(timeout);
        }
        return () => {};
    }, [ref.current, children]);

    return {
        expand, setExpand, ref, maxHeight, isLoad,
    };
}

export default useAccordion;
